import { JSONContent } from '@tiptap/core';

import { ActivitiesContentType } from 'global/constants';

export const SECTION_PRINT_CONTAINER_CLASS_NAME = 'section-print-container';

export type ActivityPrintMetadata = {
  userName?: string;
  subjectName: string;
  unitName: string;
  contentName: string;
  contentType: ActivitiesContentType;
  focusQuestion?: JSONContent;
  phenomena?: JSONContent;
  userClassName: string;
  imageUrl: string;
};

export const PREVIEW = 'preview';
export const PRINT = 'print';
